import { createStoreModule } from '../utils';
export default createStoreModule({
  name: 'coupon',
  modelName: 'coupons',
  crud: true,
  endpoint: '/v2/coupons'
});
